"use client";

import React from "react";
import { Compass, Map, CalendarCheck, Mountain } from "lucide-react";
const steps = [{
  id: "01",
  title: "Diagnóstico",
  desc: "Analisamos sua marca e objetivos para identificar as melhores oportunidades de impacto visual.",
  icon: Compass
}, {
  id: "02",
  title: "Estratégia",
  desc: "Planejamos cada detalhe da narrativa e estética para conectar sua marca ao público certo.",
  icon: Map
}, {
  id: "03",
  title: "Produção",
  desc: "Executamos a captação e edição com excelência técnica e olhar artístico diferenciado.",
  icon: CalendarCheck
}, {
  id: "04",
  title: "Crescimento",
  desc: "Entregamos conteúdos prontos para escalar sua presença digital e gerar resultados reais.",
  icon: Mountain
}];
export default function TheVistProcess() {
  return <section data-section-id="221500" id="como-funciona" className="py-24 bg-background text-foreground relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center max-w-2xl mx-auto mb-16 md:mb-24">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-4">
            Como funciona
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            Um processo estruturado para transformar sua visão em produções audiovisuais de alto nível.
          </p>
        </div>

        <div className="relative">
          {}
          <div className="absolute top-8 bottom-8 left-8 md:hidden border-l-2 border-dashed border-border z-0" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
            {steps.map((step, i) => <div key={step.id} data-index={i} className="relative z-10 flex flex-col md:items-center md:text-center group">
                {}
                {i !== steps.length - 1 && <div className="hidden md:block absolute top-8 left-1/2 w-full border-t-2 border-dashed border-border z-0" />}

                <div className="flex flex-row md:flex-col items-start md:items-center gap-6 md:gap-0 w-full">
                  {}
                  <div className="relative shrink-0 md:mb-8">
                    <div className="w-16 h-16 rounded-full bg-background border-2 border-border flex items-center justify-center relative z-10 shadow-sm group-hover:border-primary/50 group-hover:shadow-md transition-all duration-300">
                      <step.icon className="w-7 h-7 text-primary" />
                    </div>
                  </div>

                  {}
                  <div className="pt-2 md:pt-0 relative w-full flex-1">
                    {}
                    <div className="absolute -top-10 -left-4 md:top-[-80px] md:left-1/2 md:-translate-x-1/2 text-[80px] md:text-[140px] font-bold text-primary/5 select-none pointer-events-none transition-colors duration-500 group-hover:text-primary/10 leading-none z-0 font-default">
                      {step.id}
                    </div>

                    <div className="relative z-10">
                      <h3 className="text-xl font-semibold font-default text-foreground mb-3">
                        {step.title}
                      </h3>
                      <p className="text-muted-foreground text-sm leading-relaxed md:max-w-[260px] mx-auto font-default">
                        {step.desc}
                      </p>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}